import { query } from 'kitsu-core'
import { RequestParameters } from '~/utils/SohoApi/SohoApi'

export function serialiseParams (params: RequestParameters) {
  if (params && params.include && typeof params.include === 'object') {
    return query({
      ...params,
      include: params.include.join(',')
    })
  }

  return query(params)
}

export function prependSlash (url?: string) {
  if (typeof url === 'string') {
    return url.startsWith('/') ? url : `/${url}`
  }

  return '/'
}
